import { Modal } from '@trackman/web-shared-components';
import { useAuthorizationStore } from 'stores/AuthorizationStore';
import { useGetConfig } from 'hooks/startupHooks';
import { useTranslation } from 'react-i18next';

const LoggedOutInfoModal = () => {
  const { t } = useTranslation();
  const { isLoggedOutModalOn, setIsLoggedOutModalOn } = useAuthorizationStore();
  const { data: config } = useGetConfig();

  if (!config) return null;

  return (
    <Modal
      title={t('LoggedOut')}
      open={isLoggedOutModalOn}
      onClose={() => setIsLoggedOutModalOn(false)}
      confirmBtn={{ label: t('LoggedOut.redirect'), onClick: () => window.location.assign(config.logoutUrl) }}
      cancelBtn={{ label: t('LoggedOut.stay'), onClick: () => setIsLoggedOutModalOn(false) }}
      style={{ zIndex: 2001 }}
    >
      <div>
        <p>{t('LoggedOut.message.loggedOut')}</p>
        <p>{t('LoggedOut.message.saveProgress')}</p>
        <p>{t('LoggedOut.message.pleaseLogin')}</p>
      </div>
    </Modal>
  );
};

export default LoggedOutInfoModal;
